<template>
  <Spinner v-if="item.positionsAreLoading" :isSmall="true"/>
  <template v-else>
<!--    <div class="datatable-wrapper tabular-nums">-->
    <div class="datatable-wrapper">
      <table class="p-datatable p-datatable-striped p-datatable-sm p-datatable-hoverable-rows positions-table"
             :class="{ 'datatable--small-text': isSpoilerTable }"
             v-if="((!noActivePositions || showDeletedPositions) && item?.positions?.length) || item?.consumable">
        <thead :class="{ 'p-datatable-thead': !isSpoilerTable }">
        <tr class="table-opened-info__header-row">
          <th style="max-width: 30px"></th>
          <th :class="{'medium-width': showFinancialData && isSpoilerTable}" v-show="showFinancialData">{{ $t('Supplier') }}</th>
          <th :class="{'medium-width': showFinancialData && isSpoilerTable}">{{ $t('Code') }}</th>
          <th style="min-width: 180px">{{ $t('Name') }}</th>
          <th :class="{'small-width': showFinancialData && isSpoilerTable}">{{ $t('Qty') }}</th>
          <th :class="{'small-width': isSpoilerTable}" v-show="showFinancialData">{{ $t('purchasePriceShortLabel') }}</th>
          <th :class="{'small-width': isSpoilerTable}" v-show="showFinancialData">{{ $t('sellingPriceShortLabel') }}</th>
          <th :class="{'small-width': isSpoilerTable}" v-show="showFinancialData">{{ $t('discountShortLabel') }}</th>
          <th :class="{'small-width': isSpoilerTable}" v-show="showFinancialData">{{ $t('Sum') }}</th>
          <th :class="{'small-width': isSpoilerTable}" v-show="showFinancialData">{{ $t('Tax') }}</th>
          <th :class="{'small-width': isSpoilerTable}" v-show="showFinancialData">{{ $t('Total') }}</th>
          <th :class="{'small-width': isSpoilerTable}" v-show="showFinancialData && includesWarrantyPositions">
            <div class="p-d-flex p-ai-center" v-tooltip.top="$t('lineItemWarrantyTooltip')">
              <i class="pi pi-shield"/>
            </div>
          </th>
          <th v-show="showFinancialData">{{ $t('markupPercentLabel') }}</th>
          <th v-show="showFinancialData">{{ $t('marginLabel') }}</th>
          <th :class="{'small-width': isSpoilerTable}" v-show="showFinancialData && $store.getters.isAdminOrHigher">{{ $t('grossProfitLabel') }}</th>
          <th style="width: 3%" v-show="showFinancialData && includesRequestPositions && !isOffer"></th>
          <th style="width: 3%" v-show="showFinancialData"></th>
          <th style="width: 3%" v-show="showFinancialData && includesRequestPositions && thereIsFixedRequest && !isOffer"></th>
          <th style="width: 3%" v-show="showFinancialData && thereIsReducedRequest">
            <span class="p-d-flex p-jc-center" v-tooltip.left="$t('lineItemReturnedSpecialOrderTooltip')">
              <i class="ti-back-left"/>
            </span>
          </th>
        </tr>
        </thead>
        <tbody class="p-datatable-tbody">
        <tr v-for="(position, index) of computedActualPositions" :key="position.id ?? index">
          <td style="width: 30px" :class="{'deleted-position-td': position.status === 0}">
            <i :class="{'ti-hummer':position.type === 1,
                        'ti-truck':position.type === 2,
                        'ti-package':position.type === 3,
                        'ti-pencil':position.type === 4}">
            </i>
          </td>
          <td :class="{'deleted-position-td': position.status === 0}" v-show="showFinancialData">
            <span v-if="position.type === 1 && getPositionMasterRows(position).length"
                  class="position-master-label"
                  :class="{ 'position-master-label--multiple': getPositionMasterRows(position).length > 1 }">
              <template v-if="getPositionMasterRows(position).length > 1">
                <span v-for="item in getPositionMasterRows(position)"
                      :key="item.user_id"
                      class="position-master-label__line">
                  {{ getMasterShortName(item.master) }} {{ formatSharePercent(item.share_percent) }}%
                </span>
              </template>
              <template v-else>
                {{ getPositionMasterLabel(position) }}
              </template>
            </span>
            <span v-else-if="position.type === 2 && position.supplier">
              {{ position.supplier.company_name }}
            </span>
            <i v-else class="ti-minus"/>
          </td>

          <td :class="{'deleted-position-td': position.status === 0}">
<!--            <span v-if="position.type === 1 && position.service?.code">{{ position.service.code }}</span>-->
            <span v-if="position.code">{{ position.code }}</span>
<!--            //Dont save service code-->
            <i v-else class="ti-minus"/>
          </td>
          <td :class="{'deleted-position-td': position.status === 0}">
            <span class="word-break">
              {{ position.name }}
            </span>
            <div v-if="showFinancialData &&
                       Number(position.type) === 1 &&
                       hasCustomPositionServiceMeta(position)"
                class="position-service-meta p-text-secondary">
              <span v-if="positionHasManualWorkTime(position)"
                    class="p-d-flex p-ai-center">
                <i class="ti-time p-mr-1"/>
                {{ formatPositionWorkTime(position) }}
              </span>

<!--              <span v-if="positionHasManualWorkTime(position) && positionHasManualInvoiceQty(position)"-->
<!--                    class="position-service-meta__separator">·</span>-->

              <span v-if="positionHasManualInvoiceQty(position)" class="p-d-flex p-ai-center">
                <i class="ti-receipt p-mr-1"/>
                {{ $t('customerQtyLabel') }}: {{ formatPositionInvoiceQty(position) }}
              </span>
            </div>
            <div v-if="showServiceWorkTimeInsteadOfQty &&
                 Number(position.type) === 1 &&
                 getPositionEffectiveWorkTime(position) > 0"
                class="position-service-meta p-text-secondary">
              <span class="p-d-flex p-ai-center">
                <i class="ti-time p-mr-1"/>
                {{ formatHoursAndMinutes(getPositionEffectiveWorkTime(position)) }}
              </span>
            </div>
          </td>
<!--          <td :class="{'deleted-position-td': position.status === 0}">{{ formatDecimal(position.qty) }}</td>-->

          <td :class="{'deleted-position-td': position.status === 0}">
            <template v-if="!showServiceWorkTimeInsteadOfQty || Number(position.type) !== 1">
              {{ formatDecimal(position.qty) }}
            </template>
            <i v-else class="ti-minus"/>
          </td>

<!--          <td :class="{'deleted-position-td': position.status === 0}" v-show="showFinancialData">-->
<!--            <span v-if="position.type !== 1">{{ formatCurrency(position.purchase_price, 2, 4) }}</span>-->
<!--            <span v-else-if="$store.getters.isAccountantOrHigher">{{ formatCurrency(position.purchase_price, 2, 4) }}</span>-->
<!--            <span v-else>{{ formatCurrency(0, 2, 4) }}</span>-->
<!--          </td>-->
          <td v-show="showFinancialData"
              :class="{
                  'deleted-position-td': position.status === 0,
                  'warning-color': isPositionPriceWarningVisible(position)
              }">
            <span v-if="position.type !== 1">
                {{ formatCurrency(position.purchase_price, 2, 4) }}
            </span>

            <span v-else-if="$store.getters.isAccountantOrHigher">
              {{ formatCurrency(position.purchase_price, 2, 4) }}
            </span>
            <span v-else>
                {{ formatCurrency(0, 2, 4) }}
            </span>
          </td>

<!--          <td :class="{'deleted-position-td': position.status === 0}" v-show="showFinancialData">{{ formatCurrency(position.sell_price, 2, 4) }}</td>-->
          <td v-show="showFinancialData"
              :class="{
                  'deleted-position-td': position.status === 0,
                  'warning-color': isPositionPriceWarningVisible(position)
              }">
            {{ formatCurrency(position.sell_price, 2, 4) }}
          </td>


          <td :class="{'deleted-position-td': position.status === 0}" v-show="showFinancialData">
            <span v-if="position.discount && +position.discount">{{ formatDecimal(position.discount) }}%</span>
            <i v-else class="ti-minus"/>
          </td>
          <!--          <td :class="{'deleted-position-td': position.status === 0}">{{ formatCurrency(((position.sell_price - (((position.discount ?? 0) / 100) * position.sell_price)) * position.qty)) }}</td>-->
          <td :class="{'deleted-position-td': position.status === 0}" v-show="showFinancialData">{{ formatCurrency(position.sum) }}</td>
          <td :class="{'deleted-position-td': position.status === 0}" v-show="showFinancialData">{{ formatDecimal(position.tax_value) }}%</td>
          <!--          <td :class="{'deleted-position-td': position.status === 0}">{{ formatCurrency(((position.sell_price - (((position.discount ?? 0) / 100) * position.sell_price)) * position.qty) * (((position.tax ? position.tax.value : 0) / 100) + 1)) }}</td>-->
          <td :class="{'deleted-position-td': position.status === 0}" v-show="showFinancialData">{{ formatCurrency(position.total) }}</td>
          <td :class="{'deleted-position-td': position.status === 0}" v-show="showFinancialData && includesWarrantyPositions">
            <i v-if="position.is_warranty" class="ti-check"/>
            <i v-else class="ti-minus"/>
          </td>
          <td :class="{'deleted-position-td': position.status === 0}" v-show="showFinancialData">
            <template v-if="markupsByKey.has(markupKey(position))">
              <span>{{ markupsByKey.get(markupKey(position)) }}</span>
            </template>
            <i v-else class="ti-minus"/>
          </td>
          <td :class="{'deleted-position-td': position.status === 0}" v-show="showFinancialData">
            <template v-if="marginsByKey.has(marginKey(position))">
              <span>{{ marginsByKey.get(marginKey(position)) }}</span>
            </template>
            <i v-else class="ti-minus"/>
          </td>
          <td :class="{'deleted-position-td': position.status === 0}" v-show="showFinancialData && $store.getters.isAdminOrHigher">{{ formatCurrency(calculatePositionProfit(position)) }}</td>
          <td class="data-custom-padding" :class="{'deleted-position-td': position.status === 0}" v-show="showFinancialData && includesRequestPositions && !isOffer">
            <RequestPositionStateButton v-if="position && position.type === 2"
                                        :isDisabled="item.state === 12"
                                        :dataIsSending="dataIsSending"
                                        :orderId="item.id"
                                        :orderIsArchived="!!item.is_archived"
                                        :position="position"/>
          </td>
          <td class="data-custom-padding" :class="{'deleted-position-td': position.status === 0}" v-show="showFinancialData">
            <PositionHistoryButton :position="position" :isOffer="isOffer"/>
          </td>
          <td class="data-custom-padding" :class="{'deleted-position-td': position.status === 0}" v-show="showFinancialData && includesRequestPositions && thereIsFixedRequest && !isOffer">
            <PositionFixedQtyButton :position="position" fixedMode="all"/>
          </td>
          <td v-show="showFinancialData && thereIsReducedRequest && !isOffer" :class="{'deleted-position-td': position.status === 0}">
            <span v-if="position.reduced_qty && +position.reduced_qty" v-tooltip.left="$t('lineItemReturnedQtyTooltip')">
              <i class="ti-back-left"/>
              <span style="font-size: 0.9em; position: relative; top: -1px; margin-left: 2px">{{ +position.reduced_qty }}</span>
            </span>
          </td>
        </tr>
        <tr v-if="item.consumable && showFinancialData">
          <td>
            <i class="ti-spray"/>
          </td>
          <td>
          </td>
          <td>
          </td>
          <td>{{ item.consumable.name }}</td>
          <td>{{ formatDecimal(item.consumable.qty) }}</td>
          <td>
            <i class="ti-minus"/>
          </td>
          <td>{{ formatCurrency(item.consumable.sell_price) }}</td>
          <td>
            <span v-if="item.consumable.discount && +item.consumable.discount">{{ formatDecimal(item.consumable.discount) }}%</span>
            <i v-else class="ti-minus"/>
          </td>
          <td>{{ formatCurrency((item.consumable.sell_price - (((item.consumable.discount ?? 0) / 100) * item.consumable.sell_price)) * item.consumable.qty) }}</td>
          <td>{{ formatDecimal(item.consumable.tax_value) }}%</td>
          <td>{{ formatCurrency(((item.consumable.sell_price - (((item.consumable.discount ?? 0) / 100) * item.consumable.sell_price)) * item.consumable.qty) * ((item.consumable.tax_value / 100) + 1)) }}</td>
          <td v-show="showFinancialData && includesWarrantyPositions"></td>
          <td v-show="showFinancialData">
            <i class="ti-minus"/>
          </td>
          <td v-show="showFinancialData">
            <i class="ti-minus"/>
          </td>
          <td v-show="showFinancialData && $store.getters.isAdminOrHigher">
            <i class="ti-minus"/>
          </td>
          <td v-show="includesRequestPositions && !isOffer"></td>
          <td></td>
          <td v-show="includesRequestPositions && thereIsFixedRequest && !isOffer"></td>
          <td v-show="thereIsReducedRequest && !isOffer"></td>
        </tr>
        <tr class="table-opened-info__row--total" v-if="showFinancialData && item.positions?.length">
          <td class="no-bottom-border"></td>
          <td class="no-bottom-border"></td>
          <td class="no-bottom-border"></td>
          <td class="no-bottom-border p-text-right">
            <span class="medium-bold-text">{{ $t('Grand total') }}:</span>
          </td>
          <td class="no-bottom-border"></td>
          <td class="no-bottom-border" style="background-color: inherit">
            <span v-if="$store.getters.isAccountantOrHigher" class="medium-bold-text">{{ formatCurrency(computePurchaseSum) }}</span>
            <i v-else class="ti-minus"/>
          </td>
          <td class="no-bottom-border" style="background-color: inherit">
            <span class="medium-bold-text">{{ formatCurrency(computeSellPrice) }}</span>
          </td>
          <td class="no-bottom-border" style="background-color: inherit">
            <span v-if="computeDiscountSum && +computeDiscountSum !== 0" class="medium-bold-text">{{ formatCurrency(computeDiscountSum) }}</span>
            <i v-else class="ti-minus"/>
          </td>
          <td class="no-bottom-border" style="background-color: inherit">
            <span class="medium-bold-text">{{ formatCurrency(item.sum) }}</span>
          </td>
          <td class="no-bottom-border" style="background-color: inherit">
            <span v-if="item.tax" class="medium-bold-text">{{ formatCurrency(item.tax) }}</span>
          </td>
          <td class="no-bottom-border" style="background-color: inherit">
            <span v-if="item.tax" class="medium-bold-text">{{ formatCurrency(item.grand_total) }}</span>
          </td>
          <td v-show="showFinancialData && includesWarrantyPositions" class="no-bottom-border"></td>
          <td v-show="showFinancialData" class="no-bottom-border">
            <i class="ti-minus"/>
          </td>  <!-- Markup -->
          <td v-show="showFinancialData" class="no-bottom-border">
            <i class="ti-minus"/>
          </td>  <!-- Margin -->
          <td v-show="showFinancialData && $store.getters.isAdminOrHigher" class="no-bottom-border">
            <span class="medium-bold-text"> {{ formatCurrency(computeTotalProfit) }}</span>
          </td>
          <td v-show="includesRequestPositions && !isOffer" class="no-bottom-border"></td>
          <td class="no-bottom-border"></td>
          <td v-show="includesRequestPositions && thereIsFixedRequest && !isOffer" class="no-bottom-border"></td>
          <td v-show="thereIsReducedRequest && !isOffer" class="no-bottom-border"></td>
        </tr>
        </tbody>
      </table>
      <div v-else :class="{ 'datatable--small-text': isSpoilerTable }" style="text-align: center; padding: 35px;">
        {{ $t('No data available' )}}
      </div>
    </div>

    <div class="comments-wrap" :class="{'p-mt-3':showFinancialData || item.staff_comment || item.customer_comment || hasAnyChangeHistory}">
      <div class="comment customer-comment"
           v-if="item.customer_comment || changeHistoryCount('customer_comment') || item.customer_parts">
          <b class="p-mb-3">{{ $t('customerCommentLabel') }}:</b>
          <span class="p-ml-2 p-mr-1 created-by-customer" v-if="item.customer_parts && +item.customer_parts">
            {{ $t('Customer parts') }}
          </span>
          <TextChangeHistoryButton
              :entity="isOffer ? 'offer' : 'order'"
              :entity-id="item.id"
              kind="customer_comment"
              :count="changeHistoryCount('customer_comment')"
              class="p-ml-1"/>
          <div class="p-mt-2 balanced-text word-break pre-line">
            {{ item.customer_comment }}
          </div>
        </div>
      <div class="comment staff-comment"
           v-if="item.staff_comment || changeHistoryCount('staff_comment')">
          <b class="p-mb-3">{{ $t('internalCommentLabel') }}:</b>
          <TextChangeHistoryButton
              :entity="isOffer ? 'offer' : 'order'"
              :entity-id="item.id"
              kind="staff_comment"
              :count="changeHistoryCount('staff_comment')"
              class="p-ml-1"/>
          <InternalCommentWarningBtn v-if="!isOffer" :order="item" class="p-ml-1"/>
          <div class="p-mt-2 balanced-text word-break pre-line" :class="{'orange-color':item.is_warning}">
            {{ item.staff_comment }}
          </div>
        </div>
      <div class="comment recommendations" v-if="!isOffer && (item.recommendation || changeHistoryCount('recommendation'))">
        <b class="p-mb-3">{{ $t('Recommendations') }}:</b>
        <TextChangeHistoryButton
            entity="order"
            :entity-id="item.id"
            kind="recommendation"
            :count="changeHistoryCount('recommendation')"
            class="p-ml-1"/>
        <div class="p-mt-2 balanced-text word-break pre-line">
          {{ item.recommendation }}
        </div>
      </div>
      <div class="comment recommendations" v-if="item.additional_information">
        <div>
          <b class="p-mb-3">{{ $t('Additional information') }}:</b>
        </div>
        <div class="p-mt-2 balanced-text word-break pre-line" :class="{'orange-color':item.is_warning}">
          {{ item.additional_information }}
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import PositionHistoryButton from '@/components/PositionHistoryButton'
import PositionFixedQtyButton from '@/components/PositionFixedQtyButton'
import formatMixins from '@/mixins/formatMixins'
import RequestPositionStateButton from "@/pages/orders/components/RequestPositionStateButton";
import InternalCommentWarningBtn from "@/pages/orders/components/InternalCommentWarningBtn";
import calculateMixins from "@/mixins/calculateMixins";
import TextChangeHistoryButton from '@/components/TextChangeHistoryButton.vue'

export default {
  emits: [ 'update-items' ],
  mixins: [ formatMixins, calculateMixins ],
  components: {
    PositionHistoryButton,
    PositionFixedQtyButton,
    RequestPositionStateButton,
    InternalCommentWarningBtn,
    TextChangeHistoryButton,
  },
  name: 'PositionsTable',
  props: {
    dataIsSending: {
      type: Boolean,
      default: false
    },
    showFinancialData: {
      type: Boolean,
      default: true,
    },
    showDeletedPositions: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      required: true,
    },
    isSpoilerTable: {
      type: Boolean,
      default: false
    },
    isOffer: {
      type: Boolean,
      default: false
    },
    showServiceWorkTimeInsteadOfQty: {
      type: Boolean,
      default: false,
    },
  },
  provide() {
    return {
      positionMenusState: this.positionMenusState,
      openPositionMenu: this.openPositionMenu,
      closePositionMenus: this.closePositionMenus,
    }
  },
  data() {
    return {
      positionMenusState: {
        activeKey: null,
      },
    }
  },
  methods: {
    getPositionEffectiveWorkTime(position) {
      if (
          !position ||
          Number(position.type) !== 1 ||
          Number(position.qty ?? 0) <= 0
      ) {
        return 0
      }

      const hasManualWorkTime =
          position.work_time !== null &&
          position.work_time !== undefined

      if (hasManualWorkTime) {
        const workTime = Number(position.work_time)

        return Number.isFinite(workTime) && workTime > 0
            ? workTime
            : 0
      }

      const unitTime = Number(
          position.service?.time ?? 0
      )

      const qty = Number(position.qty ?? 0)
      const totalTime = unitTime * qty

      return Number.isFinite(totalTime) && totalTime > 0
          ? totalTime
          : 0
    },
    isPositionPriceWarningVisible(position) {
      if (!this.isPositionSellingPriceLowerThanPurchase(position)) {
        return false
      }

      return Number(position.type) !== 1 ||
          this.$store.getters.isAccountantOrHigher
    },
    getMasterFullName(master) {
      if (!master) return ''

      if (master.full_name) {
        return master.full_name
      }

      return `${master.first_name || ''} ${master.last_name || ''}`.trim()
    },

    getMasterShortName(master) {
      if (!master) return ''

      const firstName = master.first_name || ''
      const lastName = master.last_name || ''

      if (firstName && lastName) {
        return `${firstName.charAt(0)}. ${lastName}`
      }

      if (master.full_name) {
        const parts = master.full_name.trim().split(/\s+/)

        if (parts.length >= 2) {
          return `${parts[0].charAt(0)}. ${parts.slice(1).join(' ')}`
        }

        return master.full_name
      }

      return firstName || lastName || ''
    },

    formatSharePercent(value) {
      const num = Number(value)

      if (!Number.isFinite(num)) return ''

      return Number.isInteger(num) ? String(num) : num.toFixed(2)
    },

    positionHasManualWorkTime(position) {
      return (
          !!position &&
          Number(position.type) === 1 &&
          position.work_time !== null &&
          position.work_time !== undefined
      )
    },

    positionHasManualInvoiceQty(position) {
      return (
          !!position &&
          Number(position.type) === 1 &&
          position.customer_qty !== null &&
          position.customer_qty !== undefined
      )
    },

    hasCustomPositionServiceMeta(position) {
      return (
          this.positionHasManualWorkTime(position) ||
          this.positionHasManualInvoiceQty(position)
      )
    },

    formatPositionWorkTime(position) {
      return this.formatHoursAndMinutes(
          Number(position.work_time ?? 0)
      )
    },

    formatPositionInvoiceQty(position) {
      return this.formatDecimal(
          Number(position.customer_qty ?? position.qty ?? 0)
      )
    },

    getPositionMasterRows(position) {
      const rows = Array.isArray(position?.positionMasters)
          ? position.positionMasters
          : []

      if (rows.length) {
        return rows
            .map(item => {
              const master = item.master || null
              const userId = +(item.user_id || master?.id || 0)

              if (!userId) return null

              return {
                user_id: userId,
                master,
                share_percent: Number(item.share_percent ?? 0),
              }
            })
            .filter(Boolean)
      }

      if (position?.master?.id) {
        return [
          {
            user_id: +position.master.id,
            master: position.master,
            share_percent: 100,
          },
        ]
      }

      return []
    },

    getPositionMasterFullLabel(position) {
      const rows = this.getPositionMasterRows(position)

      if (!rows.length) return ''

      return rows
          .map(item => {
            const masterName = this.getMasterFullName(item.master)
            const percent = this.formatSharePercent(item.share_percent)

            return masterName
                ? `${masterName} ${percent}%`
                : `${percent}%`
          })
          .join(' · ')
    },

    getPositionMasterLabel(position) {
      const rows = this.getPositionMasterRows(position)

      if (!rows.length) return ''

      if (rows.length === 1) {
        const item = rows[0]
        const masterName = this.getMasterFullName(item.master)

        if (!masterName) {
          return ''
        }

        return Number(item.share_percent) === 100
            ? masterName
            : `${masterName} ${this.formatSharePercent(item.share_percent)}%`
      }

      return rows
          .map(item => {
            const masterName = this.getMasterShortName(item.master)
            const percent = this.formatSharePercent(item.share_percent)

            return masterName
                ? `${masterName} ${percent}%`
                : `${percent}%`
          })
          .join(' · ')
    },
    openPositionMenu(key) {
      this.positionMenusState.activeKey = key
    },

    closePositionMenus() {
      this.positionMenusState.activeKey = null
    },
    markupKey(p) {
      return p?.id ?? p?.sorting ?? `${p?.type}-${p?.code}-${p?.name}`
    },
    marginKey(p) {
      return p?.id ?? p?.sorting ?? `${p?.type}-${p?.code}-${p?.name}`
    },

    changeHistoryCount(kind) {
      const count = Number(this.item?.change_history_counts?.[kind] ?? 0)
      return Number.isFinite(count) && count > 0 ? count : 0
    },
  },
  computed: {
    markupsByKey() {
      const map = new Map()
      for (const p of (this.computedActualPositions ?? [])) {
        const key = this.markupKey(p)
        const val = this.calculateMarkup(p)
        if (val != null && val !== '') {
          map.set(key, val)
        }
      }
      return map
    },
    marginsByKey() {
      const map = new Map()
      for (const p of (this.computedActualPositions ?? [])) {
        const key = this.marginKey(p)
        const val = this.calculateMargin(p)
        if (val != null && val !== '') {
          map.set(key, val)
        }
      }
      return map
    },
    thereIsReducedRequest() {
      if (!this.item?.positions) return false
      if (this.showDeletedPositions) {
        return !!this.item.positions.find(p => p.reduced_qty && +p.reduced_qty)
      } else {
        return !!this.item.positions.find(p => p.status === 1 && p.reduced_qty && +p.reduced_qty)
      }
    },
    computePurchaseSum() {
      if (!this.item || !this.activePositions?.length) return 0

      const isPrivileged =
          this.$store.getters.isAdminOrSuperAdmin ||
          this.$store.getters.isAccountant

      let positions = this.activePositions
      if (!isPrivileged) positions = positions.filter((p) => p.type !== 1)

      return positions.reduce((sum, p) => sum + this.effectivePurchaseSum(p), 0)
    },
    computeSellPrice() {
      if (!this.item || !this.activePositions?.length) return 0
      const positionsSellPrice = this.activePositions.reduce((sum, position) => sum + +position.sell_price * position.qty, 0)
      const consumableSellPrice = this.item.consumable
          ? (+this.item.consumable.sell_price || 0) * (+this.item.consumable.qty || 0)
          : 0
      return positionsSellPrice + consumableSellPrice
    },
    computeDiscountSum() {
      if (!this.item || !this.activePositions?.length) return 0
      const positionsDiscountSum = this.activePositions.reduce((sum, position) => sum + +position.discount_sum, 0)
      const consumableDiscountSum = this.item.consumable
          ? (+this.item.consumable.discount_sum || 0)
          : 0
      return positionsDiscountSum + consumableDiscountSum
    },
    computeTotalProfit() {
      if (!this.item || !this.activePositions?.length) return 0

      const positionsSum = this.activePositions.reduce((sum, p) => sum + (+p.sum || 0), 0)
      const positionsPurchase = this.activePositions.reduce((sum, p) => sum + this.effectivePurchaseSum(p), 0)

      return positionsSum - positionsPurchase
    },
    includesRequestPositions() {
      if (!this.item.positions?.length) return false
      if (this.showDeletedPositions) {
        return !!this.item.positions.find(position => position.type === 2)
      } else {
        return !!this.item.positions.find(position => position.type === 2 && position.status === 1)
      }
    },
    includesWarrantyPositions() {
      if (!this.item.positions) return false
      if (this.showDeletedPositions) {
        return !!this.item.positions.find(position => position.is_warranty === 1)
      } else {
        return !!this.item.positions.find(position => position.is_warranty === 1 && position.status === 1)
      }
    },
    thereIsFixedRequest() {
      const positions = this.item.positions
      if (!positions?.length) return false
      if (this.showDeletedPositions) {
        return !!positions.find(p => p.fixed_qty && +p.fixed_qty)
      } else {
        return !!positions.find(p => p.status && p.fixed_qty && +p.fixed_qty)
      }
    },
    activePositions() {
      return this.item.positions?.filter(position => position.status === 1)
    },
    computedActualPositions() {
      if (this.showDeletedPositions) {
        return this.item.positions
      } else {
        return this.item.positions?.filter(position => position.status === 1)
      }
    },
    noActivePositions() {
      if (!this.item?.positions) return false
      return !this.item.positions.find(position => position.status === 1)
    },
    hasAnyChangeHistory() {
      return Object.values(this.item?.change_history_counts || {})
          .some(count => Number(count) > 0)
    },
  }
}
</script>

<style scoped lang="scss">
.datatable-wrapper {
  overflow-y: auto;
}

.positions-table {
  border-collapse: collapse;
  width: 100%;
  tr {
    .small-width {
      width: 6%;
    }
    .medium-width {
      width: 10%;
    }
    th {
      padding: 10px 7px;

    }
    td {
      padding: 7px;
      height: 45px;
    }
  }
}
.data-custom-padding {
  padding: 3px !important;
}

.datatable--small-text {
  font-size: 0.92em;
}

.no-bottom-border {
  border-bottom: none !important;
}


.comments-wrap {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4px;
  align-items: start;
  margin-bottom: 4px;

  .customer-comment,
  .staff-comment,
  .recommendations {
    padding: 10px;
  }
}

@media (max-width: 880px){
  .comments-wrap{
    grid-template-columns: 1fr;
  }
}

.position-master-label {
  display: block;
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.position-master-label--multiple {
  font-size: 12px;
  line-height: 16px;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}

.position-master-label__line {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.position-service-meta {
  display: flex;
  align-items: center;
  //flex-wrap: wrap;
  column-gap: 0.75rem;
  row-gap: 0.15rem;

  margin-top: 2px;

  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
}

//.position-service-meta__time {
//  display: inline-flex;
//  align-items: center;
//  gap: 3px;
//}

.position-service-meta__separator {
  margin: 0 1px;
}
</style>
